<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ack"> </p>
<p class="tni">Enormous thanks to Helen Garnons-Williams, Lisa Moran and Ed Victor. Also to the Writers Guild of America and the Screen Actors Guild, whose threatened strikes put me on hiatus and into prose.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded1.vue?5c2bd360